import { useOutletContext } from "react-router";

import Callout from "ds/components/Callout";
import { FeedbackVariant } from "ds/components/Feedback/types";
import { ScanRunState } from "types/generated";

import { ScanResourcesOutletContext } from "../../types";

const getCalloutVariant = (state: ScanRunState): FeedbackVariant => {
  switch (state) {
    case ScanRunState.Failed:
      return "danger";
    case ScanRunState.Canceled:
    case ScanRunState.Stopped:
    case ScanRunState.FinishedWithErrors:
      return "warning";
    case ScanRunState.Finished:
    case ScanRunState.Queued:
    case ScanRunState.Scanning:
      return "info";
  }
};

const getCalloutTitle = (state: ScanRunState) => {
  switch (state) {
    case ScanRunState.Failed:
      return "Scan run failed";
    case ScanRunState.Canceled:
      return "Scan run canceled";
    case ScanRunState.Stopped:
      return "Scan run stopped";
    case ScanRunState.FinishedWithErrors:
      return "Scan run finished with errors";
    case ScanRunState.Finished:
    case ScanRunState.Queued:
    case ScanRunState.Scanning:
      return "Note";
  }
};

const ScanResourcesNoteCallout = () => {
  const { run } = useOutletContext<ScanResourcesOutletContext>();

  if (!run?.note) {
    return null;
  }

  return (
    <Callout variant={getCalloutVariant(run.state)} title={getCalloutTitle(run.state)}>
      {run.note}
    </Callout>
  );
};

export default ScanResourcesNoteCallout;
